// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Returns20 from './Returns20.tsx';
import Returns20Circle from './Returns20Circle.tsx';
import Returns24 from './Returns24.tsx';
import Returns24Circle from './Returns24Circle.tsx';
import Returns40 from './Returns40.tsx';
import Returns48 from './Returns48.tsx';

type ReturnsProps = {
    variation: '20' | '20Circle' | '24' | '24Circle' | '40' | '48';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Returns20,
    Returns20Circle,
    Returns24,
    Returns24Circle,
    Returns40,
    Returns48,
};

const Returns: FC<ReturnsProps> = ({ variation, ...props }) => {
    const variationKey = `Returns${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Returns" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Returns;
